import { ObserversModule } from '@angular/cdk/observers';
// import { PortalModule } from '@angular/cdk/portal';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { YztTabComponent } from './yzt-tab.component';
import { YztTabSetComponent } from './yzt-tabset.component';
import { YztTabsNavComponent } from './yzt-tabs-nav.component';
import { YztTabLabelDirective } from './yzt-tab-label.directive';
import { YztTabsInkBarDirective } from './yzt-tabs-ink-bar.directive';
import { YztTabBodyComponent } from './yzt-tab-body.component';
export class YztTabsModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [ YztTabComponent, YztTabSetComponent, YztTabsNavComponent, YztTabLabelDirective, YztTabsInkBarDirective, YztTabBodyComponent ],
  exports     : [ YztTabComponent, YztTabSetComponent, YztTabsNavComponent, YztTabLabelDirective, YztTabsInkBarDirective, YztTabBodyComponent ],
  imports     : [ CommonModule, ObserversModule ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function YztTabsModule_tsickle_Closure_declarations() {
/** @type {?} */
YztTabsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
YztTabsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
